import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { getDefaultPathForUser, getUserDestinationUrl, isExternalToCurrentOrigin } from '../lib/subdomains';

export default function ProtectedRoute({ children, allowedRoles }: { children: React.ReactNode, allowedRoles?: string[] }) {
  const { user, isAuthenticated } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (user) {
    const currentPath = `${location.pathname}${location.search}${location.hash}`;
    const canonicalCurrentUrl = getUserDestinationUrl(user, currentPath);
    if (canonicalCurrentUrl && isExternalToCurrentOrigin(canonicalCurrentUrl)) {
      window.location.replace(canonicalCurrentUrl);
      return null;
    }
  }

  if (allowedRoles && user && !allowedRoles.includes(user.role)) {
    const fallback = getDefaultPathForUser(user);
    const fallbackUrl = getUserDestinationUrl(user, fallback);
    if (fallbackUrl && isExternalToCurrentOrigin(fallbackUrl)) {
      window.location.replace(fallbackUrl);
      return null;
    }
    return <Navigate to={fallback} replace />;
  }

  return <>{children}</>;
}
